<style scoped>
    @import '../../css/base/variables.css';
    .gencode {
        padding-bottom: 30px;
    }
    .code-type-select {

        & > * {
             vertical-align: middle;
        }

        & .code-tip {
            left: 28px;
        }
    }

    .type-label + .type-label {
        position: relative;
        margin-left: 20px;
    }
    .tooltip {
        font-size: 16px;
        line-height: 1;
        margin-left: 5px;
        margin-right: 10px;
        color: #aaa;
    }

    .note-text {
        margin-top: 15px;
        padding: 0;
        font-size: 12px;
        color: #a3b1bf;
    }

    .content .content-part .modal-content {
        min-width: 900px;
        max-height: 700px;
    }

    table {
        width: 100%;
    }
    thead {
        background: #606d80;
        height: 35px;
        color: #fff;
    }

    th, td {
        text-align: left;
        padding: 8px;
        line-height: 1.42857143;
        vertical-align: top;
        border-top: 1px solid #ddd;
    }
    .get-code-text {
      float: right;
      margin-top: -5px;
    }
</style>

<template lang="pug">
.content-part
    .gencode
        .gencode-select
            domain-select(@change="onDomainChange", extra="为网站$domain添加监测代码")
            .code-type-select
                span 选择代码类型：
                template(v-for="option in codeTypes")
                    label.type-label(@change="changeCodeType(option.value)")
                        input(
                            type="radio",
                            name="codeType",
                            v-model="currentCodeType",
                            :value="option.value",
                            :checked="currentCodeType === option.value"
                        )
                        i
                        span {{option.title}}
                        .code-tip(v-if="!isBaseMode && currentCodeType === option.value")
                            i.fa.fa-info-circle(style="margin-right: 5px;")
                            | 获取{{currentCodeTypeDesc}}，需要先安装基础流量代码。

                a.btn.btn-primary.btn-big.get-code-text(
                  target="_blank",
                  v-show="domainSource != 'mv'",
                  v-bind:href="'/dist/text.html?dmid=' + domainId"
                  ) 
                  | 获取说明文档

        div
            .gencode-index
                span.gen-index  ①
                span.gen-text 获取初始代码
            div.code
              pre#gencode-pre(v-html="currentJSCodeEscaped", ref="jsCodeDOM")
 
            .gencode-index(v-if="!isBaseMode")
                span.gen-index  ②
                span.gen-text 代码配置
                span.gen-des(v-html="codeConfTip")
                span.gen-action(@click="showConfModal",
                  v-show="currentCodeType != 'register'") 
                  | 查看配置变量

            .gencode-index
                span.gen-index  {{ isBaseMode ? '②' : '③' }}
                span.gen-text 代码安装
                span.gen-des
                    | 请将框内代码复制到您网站
                    em {{installPageName}}
                    | 的&lt;/body&gt;前，添加成功后立即开始统计。

            .gencode-index(v-if="isBaseMode")
                span.gen-index  ③
                span.gen-text 代码检查
                span.gen-des 代码配置成功后，点击代码检查查看是否是否安装成功。
                span.gen-action.curptr(@click="goToCheck") 代码检查

            .gencode-index
                span.gen-index ④
                span.gen-text 安装完成
                span.gen-des 代码安装成功后第二天可以查看数据。

            .note-text （注：加载360统计代码不会影响您网页的正常显示和加载速度，请放心添加。）
 
    div(@click="interceptMaskClick")
        v-modal(
            :visible="shouldShowModal",
            v-if="!isBaseMode",
            @closemodal="shutConfModal"
            title="查看配置变量（变量可以根据您的要求进行配置）"
        )
            .modal-content
                table
                    thead
                        tr
                            th 字段
                            th 说明
                    tbody
                        tr(v-for="item in varConfig")
                            td {{item[0]}}
                            td {{item[1]}}
             
</template>

<script>
    import qs from 'query-string'
    import VAR_CONFIG from './CODE_VAR_CONFIG';
    
    export default {
        data() {
            return {
                domainSource: '',
                shouldShowModal: false,
                currentJSCode: '',
                currentJSCodeEscaped: '',
                currentCodeType: 'base',
                codeTypes: [{
                    value: 'base',
                    title: '基础流量代码',
                    page: '全部页面',
                    confTip: '',
                    tip: '用于收集网站基础数据，计算访问量、浏览量、访客数等基础流量数据；用于回传其他代码数据，是安装其他代码的前提条件。'
                }, {
                    value: 'goods',
                    title: '商品回传代码',
                    page: '商品详情页面',
                    confTip: `初始代码需要用户对商品id、供应商id进行配置，其他商品信息需要进入
                              <a href="http://product.dmp.360.cn" target="_blank">商品库（http://product.dmp.360.cn/）</a>
                              进行feed传输。`,
                    tip: '用于收集网站的商品数据（商品品牌、名称、价格等），计算选购率；用于投放单品重定向广告。'
                }, {
                    value: 'order',
                    title: '订单回传代码',
                    page: '购物车完成页',        
                    confTip: '初始代码需要用户自己配置，点击查看具体需要配置的变量及说明。',
                    tip: '用于收集网站的订单数据（订单号、金额等），计算订单转化率、订购转化率，追溯订单来源。'
               }, {
                    value: 'register',
                    title: '注册回传代码',
                    confTip: '初始代码需要用户对注册id进行配置。',
                    page: '注册完成页',        
                    tip: ''
               }, {
                    value: 'shoppingcart',
                    title: '购物车回传代码',
                    page: '我的购物车',
                    confTip: '初始代码需要用户自己配置，点击查看具体需要配置的变量及说明。',
                    tip: '用于监测用户加入购物车行为，计算推车数、推车率等数据。'
               }]
            };
        },

        computed: {
            domainId() {
              return this.$store.state.domainId
            },
            currentCodeTypeDesc() {
                let type = _.find(this.codeTypes, { value: this.currentCodeType })
                return type['title'];
            },
            installPageName() {
                let type = _.find(this.codeTypes, { value: this.currentCodeType });
                return _.result(type, 'page');
            },
            isBaseMode() {
                return this.currentCodeType === 'base';
            },
            varConfig() {
                return VAR_CONFIG[this.currentCodeType];
            },
            codeConfTip() {
                let tip = _.find(this.codeTypes, { value: this.currentCodeType })
                return tip['confTip']
            }
        },
        created() {
          if(_.has(this.$store.state.paramsCrossPage, 'codeType')) {
            this.currentCodeType = this.$store.state.paramsCrossPage.codeType
          }
          const urlParams = qs.parse(location.search)
          if (urlParams.codeType) {
            this.currentCodeType = urlParams.codeType
          }
        },
        methods: {
            changeCodeType(type) {
                this.currentJSCodeEscaped = '请稍后，正在获取代码中...';
                this.currentJSCode = '';
                this.fetchJSCode(type);
            },

            onDomainChange() {
                this.changeCodeType(this.currentCodeType);
            },

            // 请求脚本模板
            fetchJSCode(type) {
                this.$http.get('/api/domain/jscode', {
                    params: {
                        type,
                        domainId: this.$store.state.currentDomain.id
                    }
                })
                .then(r => r.json())
                .then(({ errno, errmsg, data, source }) => {
                    if (errno !== 0) {
                        throw { errmsg };
                    } else {
                        this.domainSource = source || ''
                        this.currentJSCodeEscaped = this.htmlEscape(data);
                        this.$nextTick(function () {
                            this.currentJSCode = this.$refs.jsCodeDOM.innerText;
                        });
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$Modal.warn(e.errmsg || '请求失败，请检查网络连接');
                });
            },

            // 数据转换
            htmlEscape(data) {
                if (this.currentCodeType === 'base') {
                   return data.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                }

                data = data.replace('<script type="text/javascript">', '&lt;script type="text/javascript"&gt;');
                data = data.replace('<\/script>', '&lt;/script&gt;');
                return data;
            },

            goToCheck() {
                this.$emit('viewChange', 'check-code');
            },

            showConfModal() {
                this.shouldShowModal = true;
            },

            shutConfModal() {
                this.shouldShowModal = false;
            },

            interceptMaskClick(e) {
                if (/(^|\s)modal-mask\s*/.test(e.target.className)) {
                    this.shouldShowModal = false;
                }
            }
        },
        destroyed () {
          this.$store.commit('SET_CROSS_PARAM', {})
        }
    }
</script>




// WEBPACK FOOTER //
// gencode_get.vue?6567ce90